import * as React from 'react';
import 'jquery-ui/ui/widgets/draggable';
import 'react-bootstrap';
import './styles.css';

export interface Props {
    popupShowed?: () => void;
    popupHidden?: () => void;
    title: string;
    closeIcon?: boolean;
    footer?: JSX.Element;
    extendClass?: string;
    modalLarge?: boolean;
    // modalTop is used by lockscreen
    modalTop?: boolean;
    close?: () => void;
    underHeader?: JSX.Element;
    modalWarning?: boolean;
}

class Popup extends React.Component<Props, {}> {
    popupElement: HTMLDivElement;
    draggableElement: HTMLDivElement;
    constructor(props: Props) {
        
        super(props);
    }

    componentDidMount(): void {
        const { popupShowed, popupHidden } = this.props;
        $(this.draggableElement).draggable({
            containment: 'document',
            handle: '.modal-header',
            cancel: '.modal-title'
        });
        if (popupShowed) {
            $(this.popupElement).on('shown.bs.modal', function () {
                popupShowed();
            });
        }
        if (popupHidden) {
            $(this.popupElement).on('hidden.bs.modal', function () {
                popupHidden();
            });
        }
    }

    componentWillUnmount(): void {
        $(this.draggableElement).draggable('destroy');
        this.close();
    }

    open = (): void => {
        $(this.popupElement).modal('show');
    }

    close = (): void => {
        $(this.popupElement).modal('hide');
    }

    render(): JSX.Element {
        const { children, footer, extendClass, modalLarge, modalTop, modalWarning, title, closeIcon } = this.props;
        return (
            <div
                ref={(div: HTMLDivElement) => { this.popupElement = div; }}
                className={'modal' + (modalWarning ? ' modal-warning' : '') + (modalTop ? ' modal-top' : '')}
                tabIndex={-1}
                role="dialog"
                data-keyboard="false" // disable close popup by pressing esc
                data-backdrop="static" // disable close popup by clicking outside
            >
                {/* tslint:disable-next-line:jsx-alignment */}
                <div className={'modal-dialog modal-dialog-centered' + (extendClass ? ' ' + extendClass : '')}>
                    <div ref={(div: HTMLDivElement) => { this.draggableElement = div; }} className="modal-content">
                        <div style={{ cursor: 'move' }} className="modal-header">
                            {(closeIcon) ?
                                (
                                    <button id="popupCloseIcon" draggable={false} type="button" className="close" onClick={this.props.close}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                ) : null
                            }
                            {
                                title ?
                                    <h4 className="modal-title custom-popup-header">{title}</h4>
                                    : null
                            }
                        </div>
                        <div className={'modal-body' + (modalLarge ? ' modal-body-large' : '')} draggable={false}>
                            {children}
                        </div>
                        {(footer) ?
                            (
                                <div className="modal-footer" draggable={false}>{footer}</div>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Popup;


// WEBPACK FOOTER //
// ./src/components/shared/Popup/PopupNewUI.tsx